import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { projectSettingServicedeskResolutionManagementRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskResolutionManagementRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { servicedeskResolutionManagementPageEntrypoint } from './ui/service-desk-resolution-management/servicedeskResolutionManagementPageEntrypoint.tsx';

export const projectSettingServicedeskResolutionManagementRouteEntry: ReturnType<
	typeof createEntry
> = createEntry(projectSettingServicedeskResolutionManagementRoute, () => ({
	group: 'project-settings-servicedesk',
	ufoName: 'jsm-rovo-service-agent-settings',
	layout: serviceProjectLayout,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,
		sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
	},
	entryPoint: () => servicedeskResolutionManagementPageEntrypoint,

	resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
	perfMetricKey: 'jsm-resolution-management-settings',

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingServicedeskResolutionManagementRouteEntry.tsx',
			whichExportToUse: 'projectSettingServicedeskResolutionManagementRouteEntry',
		},

		enabled: true,
	},
}));
